export default __webpack_public_path__ + "a6379f19b00790c5f2534067bdeda97e.png";